
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
class $6b0c0d5bde4dade9$export$3b14aa8c543ca7db extends Error {
    constructor(message){
        super(message);
    }
}


class $b5ab58a39619b6e0$export$16fa2f45be04daa8 {
    entity;
    application;
    constructor(entity){
        this.entity = entity;
        this.application = entity.application;
    }
    beforeUpdate() {}
    update() {}
    afterUpdate() {}
    start() {}
    stop() {}
}
class $b5ab58a39619b6e0$export$6a2dee56334a54b2 {
    #map = new Map();
    get(type) {
        const comp = this.#map.get(type);
        if (!comp) return null;
        if (!(comp instanceof type)) throw new Error("invalid map");
        return comp;
    }
    unwrap_get(type) {
        const v = this.get(type);
        if (v === null) throw new TypeError("Component not fount");
        return v;
    }
    add(comp) {
        this.#map.set(comp.constructor, comp);
    }
    remove(type) {
        const comp = this.#map.get(type);
        if (!comp) return null;
        if (!(comp instanceof type)) throw new Error("invalid map");
        this.#map.delete(type);
        return comp;
    }
    has(...types) {
        return types.every((t)=>this.#map.has(t));
    }
    values() {
        return this.#map.values();
    }
}
class $b5ab58a39619b6e0$export$bc644a473284d944 {
    application;
    #spawned;
    #components;
    #children;
    #parent;
    get components() {
        return this.#components;
    }
    get children() {
        return this.#children;
    }
    get parent() {
        return this.#parent;
    }
    constructor(application, parent = null){
        this.application = application;
        this.#spawned = false;
        this.#components = new $b5ab58a39619b6e0$export$6a2dee56334a54b2();
        this.#children = new Set();
        this.#parent = null;
        if (parent) parent.children.add(this);
        this.#parent = parent;
    }
    addComponent(comp) {
        if (comp.entity !== this) throw new Error("wrong entity for component");
        this.#components.add(comp);
        if (this.#spawned) comp.start();
    }
    removeComponent(type) {
        const t = this.#components.remove(type);
        if (!t) return t;
        if (this.#spawned) t.stop();
        return t;
    }
    get isSpawned() {
        return this.#spawned;
    }
    checkForCycles(found = new Set()) {
        found = new Set([
            ...found,
            this
        ]);
        for (const child of this.#children){
            if (found.has(child)) throw new Error("Invalid scene graph (cycle detected)");
            if (child.parent !== this) throw new Error("Not parent of child");
            child.checkForCycles(found);
        }
    }
    addChild(child) {
        if (this.#children.has(child)) return;
        if (child.parent) throw new Error("Child already has a parent");
        if (child.isSpawned) throw new Error("Child cannot be spawned before adding");
        this.#children.add(child);
        child.#parent = this;
        this.checkForCycles();
        if (this.isSpawned) child.onSpawn();
    }
    removeChild(child) {
        if (!this.#children.has(child)) return;
        this.#children.delete(child);
        child.#parent = null;
        if (child.isSpawned) child.onDespawn();
    }
    onSpawn() {
        this.#spawned = true;
        for (const comp of this.components.values())comp.start();
        for (const child of this.children)child.onSpawn();
    }
    onDespawn() {
        this.#spawned = false;
        for (const comp of this.components.values())comp.stop();
        for (const child of this.children)child.onDespawn();
    }
    beforeUpdate() {
        if (!this.#spawned) throw new Error("should not update if not spawned");
        for (const comp of this.components.values())comp.beforeUpdate();
        for (const child of this.children)child.beforeUpdate();
    }
    update() {
        if (!this.#spawned) throw new Error("should not update if not spawned");
        for (const comp of this.components.values())comp.update();
        for (const child of this.children)child.update();
    }
    afterUpdate() {
        if (!this.#spawned) throw new Error("should not update if not spawned");
        for (const comp of this.components.values())comp.afterUpdate();
        for (const child of this.children)child.afterUpdate();
    }
}


const $1669b27dd88d6d65$export$2329c99376c9d0a4 = 6.67430e-11;
function $1669b27dd88d6d65$export$7d15b64cf5a3a4c4(val, min, max) {
    if (min !== null && val < min) return min;
    if (max !== null && val > max) return max;
    return val;
}
function $1669b27dd88d6d65$export$3a89f8d6f6bf6c9f(from, to, t) {
    return from * (1 - t) + to * t;
}
function $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9(from, to, dt, halfLife) {
    return to + (from - to) * 2 ** (-dt / halfLife);
}
function $1669b27dd88d6d65$export$268edf54634cf0a0(from, to, modulo, dt, halfLife) {
    to = (to % modulo + modulo) % modulo;
    from = (from % modulo + modulo) % modulo;
    if (Math.abs(to - from) > Math.PI) {
        if (to < from) to += modulo;
        else to -= modulo;
    }
    return $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9(from, to, dt, halfLife);
}
function $1669b27dd88d6d65$export$ec8f24324718cffc(mean = 0, stdev = 1) {
    const u = 1 - Math.random(); // Converting [0,1) to (0,1]
    const v = Math.random();
    const z = Math.sqrt(-2 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
    // Transform to the desired mean and standard deviation:
    return z * stdev + mean;
}
function $1669b27dd88d6d65$export$ff1d6938d9ca968b(n) {
    return Math.abs(n) <= 1e-10;
}


class $c3a2047b9f740e67$export$4f2e09f18f57ee0a extends Error {
    a;
    b;
    constructor(a, b){
        super("invalid dimensions");
        this.a = a;
        this.b = b;
    }
}
class $c3a2047b9f740e67$export$45537c63b27c57ea {
    vals;
    constructor(...vals){
        this.vals = Object.freeze(vals);
    }
    get dims() {
        return this.vals.length;
    }
    static splat(dim, val) {
        return new $c3a2047b9f740e67$export$45537c63b27c57ea(...new Array(dim).fill(val));
    }
    static random(dim) {
        return new $c3a2047b9f740e67$export$45537c63b27c57ea(...new Array(dim).fill(null).map(()=>Math.random()));
    }
    eq(first, ...vals) {
        if (first instanceof $c3a2047b9f740e67$export$45537c63b27c57ea && vals.length === 0) {
            if (first.dims !== this.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, first);
            return this.vals.every((val, i)=>val === first.vals[i]);
        }
        if (typeof first === "number" && vals.length === 0) return this.eq($c3a2047b9f740e67$export$45537c63b27c57ea.splat(this.dims, first));
        if (typeof first === "number" && vals.length === this.dims - 1) return this.eq(new $c3a2047b9f740e67$export$45537c63b27c57ea(first, ...vals));
        throw new TypeError("wrong types");
    }
    add(first, ...vals) {
        if (first instanceof $c3a2047b9f740e67$export$45537c63b27c57ea && vals.length === 0) {
            if (first.dims !== this.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, first);
            return new $c3a2047b9f740e67$export$45537c63b27c57ea(...this.vals.map((val, i)=>val + first.vals[i]));
        }
        if (typeof first === "number" && vals.length === 0) return this.add($c3a2047b9f740e67$export$45537c63b27c57ea.splat(this.dims, first));
        if (typeof first === "number" && vals.length === this.dims - 1) return this.add(new $c3a2047b9f740e67$export$45537c63b27c57ea(first, ...vals));
        throw new TypeError("wrong types");
    }
    sub(first, ...vals) {
        if (first instanceof $c3a2047b9f740e67$export$45537c63b27c57ea && vals.length === 0) {
            if (first.dims !== this.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, first);
            return new $c3a2047b9f740e67$export$45537c63b27c57ea(...this.vals.map((val, i)=>val - first.vals[i]));
        }
        if (typeof first === "number" && vals.length === 0) return this.sub($c3a2047b9f740e67$export$45537c63b27c57ea.splat(this.dims, first));
        if (typeof first === "number" && vals.length === this.dims - 1) return this.sub(new $c3a2047b9f740e67$export$45537c63b27c57ea(first, ...vals));
        throw new TypeError("wrong types");
    }
    mul(first, ...vals) {
        if (first instanceof $c3a2047b9f740e67$export$45537c63b27c57ea && vals.length === 0) {
            if (first.dims !== this.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, first);
            return new $c3a2047b9f740e67$export$45537c63b27c57ea(...this.vals.map((val, i)=>val * first.vals[i]));
        }
        if (typeof first === "number" && vals.length === 0) return this.mul($c3a2047b9f740e67$export$45537c63b27c57ea.splat(this.dims, first));
        if (typeof first === "number" && vals.length === this.dims - 1) return this.mul(new $c3a2047b9f740e67$export$45537c63b27c57ea(first, ...vals));
        throw new TypeError("wrong types");
    }
    div(first, ...vals) {
        if (first instanceof $c3a2047b9f740e67$export$45537c63b27c57ea && vals.length === 0) {
            if (first.dims !== this.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, first);
            return new $c3a2047b9f740e67$export$45537c63b27c57ea(...this.vals.map((val, i)=>val / first.vals[i]));
        }
        if (typeof first === "number" && vals.length === 0) return this.div($c3a2047b9f740e67$export$45537c63b27c57ea.splat(this.dims, first));
        if (typeof first === "number" && vals.length === this.dims - 1) return this.div(new $c3a2047b9f740e67$export$45537c63b27c57ea(first, ...vals));
        throw new TypeError("wrong types");
    }
    addAxis(index, value) {
        const n = [
            ...this.vals
        ];
        n.splice(index, 0, value);
        return new $c3a2047b9f740e67$export$45537c63b27c57ea(...n);
    }
    lerp(other, t) {
        if (this.dims !== other.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, other);
        return this.mul(1 - t).add(other.mul(t));
    }
    expDecay(other, dt, halfLife) {
        if (this.dims !== other.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, other);
        return new $c3a2047b9f740e67$export$45537c63b27c57ea(...this.vals.map((val, i)=>(0, $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9)(val, other.vals[i], dt, halfLife)));
    }
    dot(other) {
        if (this.dims !== other.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, other);
        return this.vals.reduce((sum, val, i)=>sum + val * other.vals[i], 0);
    }
    norm2() {
        return this.dot(this);
    }
    norm() {
        return Math.sqrt(this.norm2());
    }
    normalize() {
        return this.div(this.norm());
    }
    clamp(min, max) {
        if (min !== null && this.dims !== min.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, min);
        if (max !== null && this.dims !== max.dims) throw new $c3a2047b9f740e67$export$4f2e09f18f57ee0a(this, max);
        return new $c3a2047b9f740e67$export$45537c63b27c57ea(...this.vals.map((val, i)=>(0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(val, min?.vals[i] ?? null, max?.vals[i] ?? null)));
    }
    as_vec2() {
        if (this.vals.length < 2) throw new Error("Cannot convert to vec2: not enough elements");
        return new $c3a2047b9f740e67$export$ac4bca90992eed1(this.vals[0], this.vals[1]);
    }
    as_vec3() {
        if (this.vals.length < 3) throw new Error("Cannot convert to vec3: not enough elements");
        return new $c3a2047b9f740e67$export$838423f3adec30fa(this.vals[0], this.vals[1], this.vals[2]);
    }
}
class $c3a2047b9f740e67$export$ac4bca90992eed1 extends $c3a2047b9f740e67$export$45537c63b27c57ea {
    constructor(x, y){
        super(x, y);
    }
    static splat(val) {
        return new $c3a2047b9f740e67$export$ac4bca90992eed1(val, val);
    }
    static random() {
        return new $c3a2047b9f740e67$export$ac4bca90992eed1(Math.random(), Math.random());
    }
    get x() {
        return this.vals[0];
    }
    with_x(val) {
        return new $c3a2047b9f740e67$export$ac4bca90992eed1(val, this.y);
    }
    get u() {
        return this.vals[0];
    }
    with_u(val) {
        return new $c3a2047b9f740e67$export$ac4bca90992eed1(val, this.y);
    }
    get y() {
        return this.vals[1];
    }
    with_y(val) {
        return new $c3a2047b9f740e67$export$ac4bca90992eed1(this.x, val);
    }
    get v() {
        return this.vals[1];
    }
    with_v(val) {
        return new $c3a2047b9f740e67$export$ac4bca90992eed1(this.x, val);
    }
}
class $c3a2047b9f740e67$export$838423f3adec30fa extends $c3a2047b9f740e67$export$45537c63b27c57ea {
    constructor(x, y, z){
        super(x, y, z);
    }
    static splat(val) {
        return new $c3a2047b9f740e67$export$838423f3adec30fa(val, val, val);
    }
    static random() {
        return new $c3a2047b9f740e67$export$838423f3adec30fa(Math.random(), Math.random(), Math.random());
    }
    static ZERO = $c3a2047b9f740e67$export$838423f3adec30fa.splat(0);
    static UP = new $c3a2047b9f740e67$export$838423f3adec30fa(0, 1, 0);
    get x() {
        return this.vals[0];
    }
    get y() {
        return this.vals[1];
    }
    get z() {
        return this.vals[2];
    }
    cross(other) {
        return new $c3a2047b9f740e67$export$838423f3adec30fa(this.y * other.z - this.z * other.y, this.z * other.x - this.x * other.z, this.x * other.y - this.y * other.x);
    }
}
class $c3a2047b9f740e67$export$b973696b5f65b53b extends $c3a2047b9f740e67$export$45537c63b27c57ea {
    constructor(x, y, z, w){
        super(x, y, z, w);
    }
    static splat(val) {
        return new $c3a2047b9f740e67$export$b973696b5f65b53b(val, val, val, val);
    }
    static random() {
        return new $c3a2047b9f740e67$export$b973696b5f65b53b(Math.random(), Math.random(), Math.random(), Math.random());
    }
    get x() {
        return this.vals[0];
    }
    get y() {
        return this.vals[1];
    }
    get z() {
        return this.vals[2];
    }
    get w() {
        return this.vals[3];
    }
}


class $cdf9471f9e6d285f$export$892596cec99bc70e extends (0, $c3a2047b9f740e67$export$45537c63b27c57ea) {
    constructor(r, g, b, a = 1){
        super(r, g, b, a);
    }
    get r() {
        return this.vals[0];
    }
    get g() {
        return this.vals[1];
    }
    get b() {
        return this.vals[2];
    }
    get a() {
        return this.vals[3];
    }
    static BLACK = new $cdf9471f9e6d285f$export$892596cec99bc70e(0, 0, 0);
    static WHITE = new $cdf9471f9e6d285f$export$892596cec99bc70e(1, 1, 1);
    static RED = new $cdf9471f9e6d285f$export$892596cec99bc70e(1, 0, 0);
    static GREEN = new $cdf9471f9e6d285f$export$892596cec99bc70e(0, 1, 0);
    static BLUE = new $cdf9471f9e6d285f$export$892596cec99bc70e(0, 0, 1);
}




class $cbfe3793600821f0$export$83f4edd572c84121 {
    vals;
    constructor(...vals){
        if (vals.length !== 9) throw new RangeError("9 elements expected");
        this.vals = Object.freeze(vals);
    }
    static IDENT = new $cbfe3793600821f0$export$83f4edd572c84121(1, 0, 0, 0, 1, 0, 0, 0, 1);
    static scale(scale) {
        return new $cbfe3793600821f0$export$83f4edd572c84121(scale.x, 0, 0, 0, scale.y, 0, 0, 0, scale.z);
    }
    static rotateX(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        return new $cbfe3793600821f0$export$83f4edd572c84121(1, 0, 0, 0, cos, -sin, 0, sin, cos);
    }
    static rotateY(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        return new $cbfe3793600821f0$export$83f4edd572c84121(cos, 0, sin, 0, 1, 0, -sin, 0, cos);
    }
    static rotateZ(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        return new $cbfe3793600821f0$export$83f4edd572c84121(cos, -sin, 0, sin, cos, 0, 0, 0, 1);
    }
    static looking_at(from, to, up) {
        const forward = to.sub(from).normalize().as_vec3();
        const right = forward.cross(up).normalize().as_vec3();
        const newUp = right.cross(forward).normalize().as_vec3();
        return new $cbfe3793600821f0$export$83f4edd572c84121(right.x, newUp.x, -forward.x, right.y, newUp.y, -forward.y, right.z, newUp.z, -forward.z);
    }
    get(row, col) {
        if (row >= 3 || col >= 3 || row < 0 || col < 0) throw new RangeError("out of bound get");
        return this.vals[col + row * 3];
    }
    column(col) {
        if (col >= 3 || col < 0) throw new RangeError("out of bound get");
        return new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(this.vals[col], this.vals[col + 3], this.vals[col + 6]);
    }
    row(row) {
        if (row >= 3 || row < 0) throw new RangeError("out of bound get");
        return new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(this.vals[row * 3], this.vals[row * 3 + 1], this.vals[row * 3 + 2]);
    }
    expand() {
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(this.vals[0], this.vals[1], this.vals[2], 0, this.vals[3], this.vals[4], this.vals[5], 0, this.vals[6], this.vals[7], this.vals[8], 0, 0, 0, 0, 1);
    }
    expandMut() {
        return new $cbfe3793600821f0$export$c2c18cb318217958([
            this.vals[0],
            this.vals[1],
            this.vals[2],
            0,
            this.vals[3],
            this.vals[4],
            this.vals[5],
            0,
            this.vals[6],
            this.vals[7],
            this.vals[8],
            0,
            0,
            0,
            0,
            1
        ]);
    }
    transpose() {
        return new $cbfe3793600821f0$export$83f4edd572c84121(this.vals[0], this.vals[3], this.vals[6], this.vals[1], this.vals[4], this.vals[7], this.vals[2], this.vals[5], this.vals[8]);
    }
    add(other) {
        return new $cbfe3793600821f0$export$83f4edd572c84121(...this.vals.map((v, i)=>v + other.vals[i]));
    }
    sub(other) {
        return new $cbfe3793600821f0$export$83f4edd572c84121(...this.vals.map((v, i)=>v - other.vals[i]));
    }
    mul(other) {
        if (other instanceof (0, $c3a2047b9f740e67$export$838423f3adec30fa)) return new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(this.column(0).dot(other), this.column(1).dot(other), this.column(2).dot(other));
        // yes this is very slow
        // what you gonna do about it ?
        return new $cbfe3793600821f0$export$83f4edd572c84121(this.row(0).dot(other.column(0)), this.row(0).dot(other.column(1)), this.row(0).dot(other.column(2)), this.row(1).dot(other.column(0)), this.row(1).dot(other.column(1)), this.row(1).dot(other.column(2)), this.row(2).dot(other.column(0)), this.row(2).dot(other.column(1)), this.row(2).dot(other.column(2)));
    }
}
class $cbfe3793600821f0$export$21c0e3d5e995d7e1 {
    vals;
    constructor(val1, ...vals){
        if (typeof val1 === "number") this.vals = Object.freeze([
            val1,
            ...vals
        ]);
        else if (Array.isArray(val1)) this.vals = Object.freeze(val1);
        else throw new TypeError("invalid");
        if (this.vals.length !== 16) throw new RangeError("9 elements expected");
    }
    static IDENT = new $cbfe3793600821f0$export$21c0e3d5e995d7e1(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    static fromTranslation(trans) {
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(1, 0, 0, trans.x, 0, 1, 0, trans.y, 0, 0, 1, trans.z, 0, 0, 0, 1);
    }
    static newPerspective(cfg) {
        const f = Math.tan(Math.PI * 0.5 - 0.5 * cfg.fov_radians);
        const rangeInv = 1 / (cfg.near - cfg.far);
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(f / cfg.aspect, 0, 0, 0, 0, f, 0, 0, 0, 0, (cfg.near + cfg.far) * rangeInv, -1, 0, 0, cfg.near * cfg.far * rangeInv * 2, 0).transpose();
    // const f = 1 / Math.tan(fov_radians / 2);
    // return new Mat4(
    //   f,     0,     0,                          0,
    //   0,     f,     0,                          0,
    //   0,     0,     -far / (far - near),        -far * near / (far - near),
    //   0,     0,     -1,                         1,
    // );
    }
    get(row, col) {
        if (row >= 4 || col >= 4 || row < 0 || col < 0) throw new RangeError("out of bound get");
        return this.vals[col + row * 4];
    }
    transpose() {
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(this.vals[0], this.vals[4], this.vals[8], this.vals[12], this.vals[1], this.vals[5], this.vals[9], this.vals[13], this.vals[2], this.vals[6], this.vals[10], this.vals[14], this.vals[3], this.vals[7], this.vals[11], this.vals[15]);
    }
    column(col) {
        if (col >= 4 || col < 0) throw new RangeError("out of bound get");
        return new (0, $c3a2047b9f740e67$export$b973696b5f65b53b)(this.vals[col], this.vals[col + 4], this.vals[col + 8], this.vals[col + 12]);
    }
    row(row) {
        if (row >= 4 || row < 0) throw new RangeError("out of bound get");
        return new (0, $c3a2047b9f740e67$export$b973696b5f65b53b)(this.vals[row * 4], this.vals[row * 4 + 1], this.vals[row * 4 + 2], this.vals[row * 4 + 3]);
    }
    add(other) {
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(...this.vals.map((v, i)=>v + other.vals[i]));
    }
    sub(other) {
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(...this.vals.map((v, i)=>v - other.vals[i]));
    }
    mul(other) {
        if (typeof other === "number") return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(...this.vals.map((val)=>val * other));
        const a = this.vals;
        const b = other.vals;
        const result = new Array(16);
        for(let row = 0; row < 4; row++)for(let col = 0; col < 4; col++)result[col + row * 4] = a[row * 4] * b[col] + a[row * 4 + 1] * b[col + 4] + a[row * 4 + 2] * b[col + 8] + a[row * 4 + 3] * b[col + 12];
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(...result);
    }
    div(other) {
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(...this.vals.map((val)=>val / other));
    }
    det() {
        const m = this.vals;
        return m[3] * m[6] * m[9] * m[12] - m[2] * m[7] * m[9] * m[12] - m[3] * m[5] * m[10] * m[12] + m[1] * m[7] * m[10] * m[12] + m[2] * m[5] * m[11] * m[12] - m[1] * m[6] * m[11] * m[12] - m[3] * m[6] * m[8] * m[13] + m[2] * m[7] * m[8] * m[13] + m[3] * m[4] * m[10] * m[13] - m[0] * m[7] * m[10] * m[13] - m[2] * m[4] * m[11] * m[13] + m[0] * m[6] * m[11] * m[13] + m[3] * m[5] * m[8] * m[14] - m[1] * m[7] * m[8] * m[14] - m[3] * m[4] * m[9] * m[14] + m[0] * m[7] * m[9] * m[14] + m[1] * m[4] * m[11] * m[14] - m[0] * m[5] * m[11] * m[14] - m[2] * m[5] * m[8] * m[15] + m[1] * m[6] * m[8] * m[15] + m[2] * m[4] * m[9] * m[15] - m[0] * m[6] * m[9] * m[15] - m[1] * m[4] * m[10] * m[15] + m[0] * m[5] * m[10] * m[15];
    }
    comatrix() {
        const m = this.vals;
        const cofactor = (r, c)=>{
            const submat = [];
            for(let i = 0; i < 4; i++){
                for(let j = 0; j < 4; j++)if (i !== r && j !== c) submat.push(m[i * 4 + j]);
            }
            const determinant3x3 = (a, b, c, d, e, f, g, h, i)=>{
                return a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g);
            };
            return ((r + c) % 2 === 0 ? 1 : -1) * determinant3x3(submat[0], submat[1], submat[2], submat[3], submat[4], submat[5], submat[6], submat[7], submat[8]);
        };
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(cofactor(0, 0), cofactor(0, 1), cofactor(0, 2), cofactor(0, 3), cofactor(1, 0), cofactor(1, 1), cofactor(1, 2), cofactor(1, 3), cofactor(2, 0), cofactor(2, 1), cofactor(2, 2), cofactor(2, 3), cofactor(3, 0), cofactor(3, 1), cofactor(3, 2), cofactor(3, 3));
    }
    inverse() {
        const det = this.det();
        if ((0, $1669b27dd88d6d65$export$ff1d6938d9ca968b)(det)) return null;
        const cofactorMatrix = this.comatrix();
        const adjugate = cofactorMatrix.transpose();
        return adjugate.div(det);
    }
    asMut() {
        return new $cbfe3793600821f0$export$c2c18cb318217958([
            ...this.vals
        ]);
    }
}
class $cbfe3793600821f0$export$c2c18cb318217958 {
    vals;
    constructor(vals){
        if (vals) {
            if (vals.length !== 16) throw new RangeError("16 elements expected");
            this.vals = vals;
        } else this.vals = new Array(16).fill(0);
    }
    static IDENT = new $cbfe3793600821f0$export$c2c18cb318217958([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ]);
    setFromTranslation(trans) {
        this.vals = [
            1,
            0,
            0,
            trans.x,
            0,
            1,
            0,
            trans.y,
            0,
            0,
            1,
            trans.z,
            0,
            0,
            0,
            1
        ];
        return this;
    }
    setPerspective(cfg) {
        const f = Math.tan(Math.PI * 0.5 - 0.5 * cfg.fov_radians);
        const rangeInv = 1 / (cfg.near - cfg.far);
        this.vals = [
            f / cfg.aspect,
            0,
            0,
            0,
            0,
            f,
            0,
            0,
            0,
            0,
            (cfg.near + cfg.far) * rangeInv,
            -1,
            0,
            0,
            cfg.near * cfg.far * rangeInv * 2,
            0
        ];
        this.transpose();
        return this;
    }
    clone() {
        return new $cbfe3793600821f0$export$c2c18cb318217958(this.vals.slice());
    }
    freeze() {
        return new $cbfe3793600821f0$export$21c0e3d5e995d7e1(this.vals);
    }
    get(row, col) {
        if (row >= 4 || col >= 4 || row < 0 || col < 0) throw new RangeError("out of bound get");
        return this.vals[col + row * 4];
    }
    transpose() {
        const m = this.vals;
        let tmp;
        tmp = m[1];
        m[1] = m[4];
        m[4] = tmp;
        tmp = m[2];
        m[2] = m[8];
        m[8] = tmp;
        tmp = m[3];
        m[3] = m[12];
        m[12] = tmp;
        tmp = m[6];
        m[6] = m[9];
        m[9] = tmp;
        tmp = m[7];
        m[7] = m[13];
        m[13] = tmp;
        tmp = m[11];
        m[11] = m[14];
        m[14] = tmp;
        return this;
    }
    column(col) {
        if (col >= 4 || col < 0) throw new RangeError("out of bound get");
        return new (0, $c3a2047b9f740e67$export$b973696b5f65b53b)(this.vals[col], this.vals[col + 4], this.vals[col + 8], this.vals[col + 12]);
    }
    row(row) {
        if (row >= 4 || row < 0) throw new RangeError("out of bound get");
        return new (0, $c3a2047b9f740e67$export$b973696b5f65b53b)(this.vals[row * 4], this.vals[row * 4 + 1], this.vals[row * 4 + 2], this.vals[row * 4 + 3]);
    }
    add(other, output) {
        const result = output || this;
        for(let i = 0; i < 16; i++)result.vals[i] = this.vals[i] + other.vals[i];
        return result;
    }
    sub(other, output) {
        const result = output || this;
        for(let i = 0; i < 16; i++)result.vals[i] = this.vals[i] - other.vals[i];
        return result;
    }
    mul(other, output) {
        const result = output || new $cbfe3793600821f0$export$c2c18cb318217958();
        if (typeof other === "number") {
            for(let i = 0; i < 16; i++)result.vals[i] = this.vals[i] * other;
            return result;
        }
        const a = this.vals;
        const b = other.vals;
        const r = result.vals;
        for(let row = 0; row < 4; row++)for(let col = 0; col < 4; col++)r[col + row * 4] = a[row * 4] * b[col] + a[row * 4 + 1] * b[col + 4] + a[row * 4 + 2] * b[col + 8] + a[row * 4 + 3] * b[col + 12];
        return result;
    }
    div(other, output) {
        const result = output || this;
        for(let i = 0; i < 16; i++)result.vals[i] = this.vals[i] / other;
        return result;
    }
    det() {
        const m = this.vals;
        return m[3] * m[6] * m[9] * m[12] - m[2] * m[7] * m[9] * m[12] - m[3] * m[5] * m[10] * m[12] + m[1] * m[7] * m[10] * m[12] + m[2] * m[5] * m[11] * m[12] - m[1] * m[6] * m[11] * m[12] - m[3] * m[6] * m[8] * m[13] + m[2] * m[7] * m[8] * m[13] + m[3] * m[4] * m[10] * m[13] - m[0] * m[7] * m[10] * m[13] - m[2] * m[4] * m[11] * m[13] + m[0] * m[6] * m[11] * m[13] + m[3] * m[5] * m[8] * m[14] - m[1] * m[7] * m[8] * m[14] - m[3] * m[4] * m[9] * m[14] + m[0] * m[7] * m[9] * m[14] + m[1] * m[4] * m[11] * m[14] - m[0] * m[5] * m[11] * m[14] - m[2] * m[5] * m[8] * m[15] + m[1] * m[6] * m[8] * m[15] + m[2] * m[4] * m[9] * m[15] - m[0] * m[6] * m[9] * m[15] - m[1] * m[4] * m[10] * m[15] + m[0] * m[5] * m[10] * m[15];
    }
    comatrix(output) {
        const result = output || new $cbfe3793600821f0$export$c2c18cb318217958();
        const m = this.vals;
        const r = result.vals;
        const cofactor = (r, c)=>{
            const submat = [];
            for(let i = 0; i < 4; i++){
                for(let j = 0; j < 4; j++)if (i !== r && j !== c) submat.push(m[i * 4 + j]);
            }
            const determinant3x3 = (a, b, c, d, e, f, g, h, i)=>{
                return a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g);
            };
            const det = determinant3x3(submat[0], submat[1], submat[2], submat[3], submat[4], submat[5], submat[6], submat[7], submat[8]);
            return ((r + c) % 2 === 0 ? 1 : -1) * det;
        };
        r[0] = cofactor(0, 0);
        r[1] = cofactor(0, 1);
        r[2] = cofactor(0, 2);
        r[3] = cofactor(0, 3);
        r[4] = cofactor(1, 0);
        r[5] = cofactor(1, 1);
        r[6] = cofactor(1, 2);
        r[7] = cofactor(1, 3);
        r[8] = cofactor(2, 0);
        r[9] = cofactor(2, 1);
        r[10] = cofactor(2, 2);
        r[11] = cofactor(2, 3);
        r[12] = cofactor(3, 0);
        r[13] = cofactor(3, 1);
        r[14] = cofactor(3, 2);
        r[15] = cofactor(3, 3);
        return result;
    }
    inverse(output) {
        const det = this.det();
        if ((0, $1669b27dd88d6d65$export$ff1d6938d9ca968b)(det)) return null;
        const result = this.comatrix(output);
        result.transpose();
        result.div(det);
        return result;
    }
}






const $86dc84cddbb87a35$export$f20c7e56e5434bbf = {
    "f32": 4,
    "u32": 4,
    "vec2f": 8,
    "vec3f": 12,
    "vec4f": 16,
    "mat4f": 64
};
function $86dc84cddbb87a35$export$c844502859f4ccd3(value, type) {
    switch(type){
        case "f32":
            return typeof value === "number";
        case "u32":
            return typeof value === "number";
        case "vec2f":
            return value instanceof (0, $c3a2047b9f740e67$export$ac4bca90992eed1) || Array.isArray(value) && value.length === 2;
        case "vec3f":
            return value instanceof (0, $c3a2047b9f740e67$export$838423f3adec30fa) || Array.isArray(value) && value.length === 3;
        case "vec4f":
            return value instanceof (0, $c3a2047b9f740e67$export$b973696b5f65b53b) || value instanceof (0, $cdf9471f9e6d285f$export$892596cec99bc70e) || Array.isArray(value) && value.length === 4;
        case "mat4f":
            return value instanceof (0, $cbfe3793600821f0$export$21c0e3d5e995d7e1) || value instanceof (0, $cbfe3793600821f0$export$c2c18cb318217958);
        default:
            // make sure type is never type -> we cover all types
            return type;
    }
}
function $86dc84cddbb87a35$export$5c20aac55651f7d1(value, type, target, byteOffset) {
    const floats = new Float32Array(target, byteOffset);
    const u32s = new Uint32Array(target, byteOffset);
    switch(type){
        case "f32":
            if (!$86dc84cddbb87a35$export$c844502859f4ccd3(value, type)) throw new Error("Invalid property value");
            floats[0] = value;
            break;
        case "u32":
            if (!$86dc84cddbb87a35$export$c844502859f4ccd3(value, type)) throw new Error("Invalid property value");
            u32s[0] = value;
            break;
        case "vec2f":
        case "vec3f":
        case "vec4f":
            if (!$86dc84cddbb87a35$export$c844502859f4ccd3(value, type)) throw new Error("Invalid property value");
            floats.set(Array.isArray(value) ? value : value.vals);
            break;
        case "mat4f":
            if (!$86dc84cddbb87a35$export$c844502859f4ccd3(value, type)) throw new Error("Invalid property value");
            floats.set(value.transpose().vals);
            break;
        default:
            // make sure type is never type -> we cover all types
            return type;
    }
}
class $86dc84cddbb87a35$export$a2d8b23205c25948 {
    renderer;
    pipeline;
    instanceDataLayout;
    customBindGroups;
    constructor(renderer, pipeline, instanceDataLayout){
        this.renderer = renderer;
        this.pipeline = pipeline;
        this.instanceDataLayout = instanceDataLayout;
        this.customBindGroups = [];
        Object.freeze(instanceDataLayout);
    }
    static fromSource(renderer, src, instanceDataLayout) {
        const device = renderer.device;
        const shaderModule = device.createShaderModule({
            code: src
        });
        const pipeline = device.createRenderPipeline({
            layout: "auto",
            vertex: {
                module: shaderModule,
                buffers: [
                    // position
                    {
                        arrayStride: 12,
                        attributes: [
                            {
                                shaderLocation: 0,
                                offset: 0,
                                format: "float32x3"
                            }
                        ]
                    },
                    // normals
                    {
                        arrayStride: 12,
                        attributes: [
                            {
                                shaderLocation: 1,
                                offset: 0,
                                format: "float32x3"
                            }
                        ]
                    },
                    // uvs
                    {
                        arrayStride: 8,
                        attributes: [
                            {
                                shaderLocation: 2,
                                offset: 0,
                                format: "float32x2"
                            }
                        ]
                    }
                ]
            },
            fragment: {
                module: shaderModule,
                targets: [
                    {
                        format: renderer.presentationFormat
                    }
                ]
            },
            primitive: {
                topology: "triangle-list",
                cullMode: "none"
            },
            depthStencil: {
                depthWriteEnabled: true,
                depthCompare: "less",
                format: "depth24plus"
            },
            multisample: renderer.sampleCount > 1 ? {
                count: renderer.sampleCount
            } : undefined
        });
        return new $86dc84cddbb87a35$export$a2d8b23205c25948(renderer, pipeline, instanceDataLayout);
    }
    getInstanceDataLayoutProperty(name) {
        return this.instanceDataLayout.properties.find((prop)=>prop.name === name) ?? null;
    }
    clean() {}
}


class $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0 extends (0, $b5ab58a39619b6e0$export$16fa2f45be04daa8) {
    #expandedAffine = null;
    #translation = (0, $c3a2047b9f740e67$export$838423f3adec30fa).ZERO;
    #translationDirty = true;
    #affine = (0, $cbfe3793600821f0$export$83f4edd572c84121).IDENT;
    #affineDirty = true;
    get translation() {
        return this.#translation;
    }
    set translation(value) {
        this.#translationDirty = true;
        this.#translation = value;
    }
    get affine() {
        return this.#affine;
    }
    set affine(value) {
        this.#affine = value;
        this.#affineDirty = true;
        this.#expandedAffine = null;
    }
    get isDirty() {
        return this.#translationDirty || this.#affineDirty;
    }
    get expandedAffine() {
        if (!this.#expandedAffine) this.#expandedAffine = this.#affine.expand();
        return this.#expandedAffine;
    }
    modelToWorld(out) {
        return (out ?? new (0, $cbfe3793600821f0$export$c2c18cb318217958)()).setFromTranslation(this.translation).mul(this.expandedAffine);
    }
    translate(trans) {
        this.translation = this.translation.add(trans).as_vec3();
        return this;
    }
    scale(scale) {
        scale = scale instanceof (0, $c3a2047b9f740e67$export$838423f3adec30fa) ? scale : (0, $c3a2047b9f740e67$export$838423f3adec30fa).splat(scale);
        this.affine = this.affine.mul((0, $cbfe3793600821f0$export$83f4edd572c84121).scale(scale));
        return this;
    }
    rotateX(angle) {
        this.affine = this.affine.mul((0, $cbfe3793600821f0$export$83f4edd572c84121).rotateX(angle));
        return this;
    }
    rotateY(angle) {
        this.affine = this.affine.mul((0, $cbfe3793600821f0$export$83f4edd572c84121).rotateY(angle));
        return this;
    }
    rotateZ(angle) {
        this.affine = this.affine.mul((0, $cbfe3793600821f0$export$83f4edd572c84121).rotateZ(angle));
        return this;
    }
    globalRotateX(angle) {
        this.affine = (0, $cbfe3793600821f0$export$83f4edd572c84121).rotateX(angle).mul(this.affine);
        return this;
    }
    globalRotateY(angle) {
        this.affine = (0, $cbfe3793600821f0$export$83f4edd572c84121).rotateY(angle).mul(this.affine);
        return this;
    }
    globalRotateZ(angle) {
        this.affine = (0, $cbfe3793600821f0$export$83f4edd572c84121).rotateZ(angle).mul(this.affine);
        return this;
    }
    lookAt(to) {
        this.affine = (0, $cbfe3793600821f0$export$83f4edd572c84121).looking_at(this.translation, to, (0, $c3a2047b9f740e67$export$838423f3adec30fa).UP);
        return this;
    }
    afterUpdate() {
        this.#affineDirty = false;
        this.#translationDirty = false;
    }
}
class $ccfb61ba2cf393a2$export$fa441e75a97e4921 extends (0, $b5ab58a39619b6e0$export$16fa2f45be04daa8) {
    fov_degrees = 45;
    near = 0.01;
    far = 1000000;
    aspect = 16 / 9;
    clearColor = (0, $cdf9471f9e6d285f$export$892596cec99bc70e).BLACK;
    withClearColor(c) {
        this.clearColor = c;
        return this;
    }
    view() {
        const transform = this.entity.components.unwrap_get($ccfb61ba2cf393a2$export$1def2aa75b7c7fe0);
        return transform.modelToWorld().freeze().inverse() ?? (0, $cbfe3793600821f0$export$21c0e3d5e995d7e1).IDENT;
    }
    projection() {
        return (0, $cbfe3793600821f0$export$21c0e3d5e995d7e1).newPerspective({
            fov_radians: this.fov_degrees / 180 * Math.PI,
            aspect: this.aspect,
            near: this.near,
            far: this.far
        });
    }
}
class $ccfb61ba2cf393a2$export$1746c996e5787f33 extends (0, $b5ab58a39619b6e0$export$16fa2f45be04daa8) {
    mesh;
    material;
    #dataUpdated;
    #visible;
    #instanceData;
    renderer;
    instanceGroup;
    constructor(entity, mesh, material){
        super(entity);
        this.mesh = mesh;
        this.material = material;
        this.#dataUpdated = false;
        this.#visible = true;
        this.#instanceData = {};
        this.instanceGroup = null;
        this.renderer = this.application.renderer;
    }
    afterUpdate() {
        this.#dataUpdated = false;
    }
    get instanceData() {
        return this.#instanceData;
    }
    get visible() {
        return this.#visible;
    }
    set visible(val) {
        if (val !== this.#visible) this.#dataUpdated = true;
        this.#visible = val;
    }
    get requireUpdate() {
        return this.#dataUpdated || this.instanceGroup === null || (this.entity.components.get($ccfb61ba2cf393a2$export$1def2aa75b7c7fe0)?.isDirty ?? false) || (this.entity.parent?.components.get($ccfb61ba2cf393a2$export$1746c996e5787f33)?.requireUpdate ?? false);
    }
    withInstanceData(name, val) {
        const prop = this.material.getInstanceDataLayoutProperty(name);
        if (prop === null) throw new Error(`Property '${name}' does not exist in material`);
        if (!(0, $86dc84cddbb87a35$export$c844502859f4ccd3)(val, prop.type)) throw new Error("Value does not match type required by material");
        this.#dataUpdated = true;
        this.#instanceData[name] = val;
        return this;
    }
    removeInstanceData(key) {
        this.#dataUpdated = true;
        delete this.#instanceData[key];
        return this;
    }
    withVisible(visible) {
        this.#dataUpdated = true;
        this.visible = visible;
        return this;
    }
}






class $7d54657999c4d04f$export$eb219d8a193c9434 {
    #members = new Set();
    #anyDataChange = false;
    #datas = new Map();
    renderer;
    mesh;
    material;
    buffers = null;
    get members() {
        return this.#members;
    }
    get instanceDataSize() {
        let size = 0;
        for (const prop of this.material.instanceDataLayout.properties)size += (0, $86dc84cddbb87a35$export$f20c7e56e5434bbf)[prop.type];
        return size;
    }
    constructor(mesh, material){
        this.mesh = mesh;
        this.material = material;
        if (mesh.renderer !== material.renderer) throw new Error("wrong");
        this.renderer = mesh.renderer;
    }
    reallocIfNeeded() {
        const targetCapacity = 2 ** Math.ceil(Math.log2(this.#members.size));
        const device = this.renderer.device;
        if (this.buffers === null || this.buffers.capacity !== targetCapacity) {
            const buffer = this.renderer.device.createBuffer({
                label: "instance buffer",
                usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
                size: this.instanceDataSize * targetCapacity
            });
            this.buffers = {
                capacity: targetCapacity,
                bindgroup: device.createBindGroup({
                    layout: this.material.pipeline.getBindGroupLayout(0),
                    entries: [
                        {
                            binding: 0,
                            resource: {
                                buffer: this.renderer.sceneUniformsBuffer
                            }
                        },
                        {
                            binding: 1,
                            resource: {
                                buffer: buffer
                            }
                        }
                    ]
                }),
                dataArray: new ArrayBuffer(targetCapacity * this.instanceDataSize),
                dataBuffer: buffer
            };
        }
        return this.buffers;
    }
    prune() {
        var member;
        return;
    }
    push(entity) {
        if (this.#members.has(entity)) throw new Error("Entity already inside instance group");
        this.#members.add(entity);
    }
    setInstanceData(entity, data) {
        this.#datas.set(entity, data);
        this.#anyDataChange = true;
    }
    removeInstanceData(entity) {
        this.#datas.delete(entity);
        this.#anyDataChange = true;
    }
    upload() {
        if (this.buffers && !this.#anyDataChange) return;
        this.#anyDataChange = false;
        const { dataArray: dataArray, dataBuffer: dataBuffer } = this.reallocIfNeeded();
        let offset = 0;
        for (const member of this.#members){
            const data = this.#datas.get(member);
            if (!data) continue;
            for (const prop of this.material.instanceDataLayout.properties){
                if (data.hasOwnProperty(prop.name)) (0, $86dc84cddbb87a35$export$5c20aac55651f7d1)(data[prop.name], prop.type, dataArray, offset);
                offset += (0, $86dc84cddbb87a35$export$f20c7e56e5434bbf)[prop.type];
            }
        }
        this.renderer.device.queue.writeBuffer(dataBuffer, 0, dataArray, 0, // only copy what's actually used
        offset);
    }
    draw(encoder) {
        if (this.buffers === null) throw new Error("cannot draw if never uploaded");
        encoder.setPipeline(this.material.pipeline);
        encoder.setBindGroup(0, this.buffers.bindgroup);
        for (const bg of this.material.customBindGroups)encoder.setBindGroup(bg.target, bg.bg);
        encoder.setVertexBuffer(0, this.mesh.positionsBuffer);
        encoder.setVertexBuffer(1, this.mesh.normalsBuffer);
        encoder.setVertexBuffer(2, this.mesh.uvsBuffer);
        const vc = this.mesh.positionsBuffer.size / 12;
        encoder.draw(vc, this.#members.size);
    }
}
class $7d54657999c4d04f$export$88530751e3977073 {
    application;
    canvas;
    ctx;
    adapter;
    device;
    sampleCount = 4;
    renderTarget = null;
    renderTargetView = null;
    depthTexture = null;
    depthTextureView = null;
    sceneUniformsBuffer;
    instanceGroups = [];
    mainCamera = null;
    presentationFormat;
    static async create(application, canvas) {
        const adapter = await navigator.gpu?.requestAdapter();
        const device = await adapter?.requestDevice({
            requiredFeatures: [
                "float32-filterable"
            ]
        });
        if (!adapter || !device) throw new (0, $6b0c0d5bde4dade9$export$3b14aa8c543ca7db)("Could not request adapter");
        return new $7d54657999c4d04f$export$88530751e3977073(application, canvas, adapter, device);
    }
    constructor(application, canvas, adapter, device){
        const ctx = canvas.getContext("webgpu");
        if (!ctx) throw new (0, $6b0c0d5bde4dade9$export$3b14aa8c543ca7db)("Could not get webgpu context");
        this.application = application;
        this.canvas = canvas;
        this.ctx = ctx;
        this.adapter = adapter;
        this.device = device;
        this.sceneUniformsBuffer = device.createBuffer({
            size: 64,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.UNIFORM
        });
        this.presentationFormat = navigator.gpu.getPreferredCanvasFormat();
        ctx.configure({
            device: device,
            format: this.presentationFormat
        });
    }
    drawCallCount() {
        return this.instanceGroups.length;
    }
    resize() {
        const device = this.device;
        const width = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.canvas.width, 1, device.limits.maxTextureDimension2D);
        const height = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.canvas.height, 1, device.limits.maxTextureDimension2D);
        if (this.depthTexture?.width === this.canvas.width && this.depthTexture?.height === this.canvas.height) return;
        this.renderTarget?.destroy();
        this.depthTexture?.destroy();
        if (this.sampleCount > 1) {
            this.renderTarget = device.createTexture({
                size: [
                    width,
                    height
                ],
                format: this.presentationFormat,
                sampleCount: this.sampleCount,
                usage: GPUTextureUsage.RENDER_ATTACHMENT
            });
            this.renderTargetView = this.renderTarget.createView();
        } else {
            this.renderTarget = null;
            this.renderTargetView = null;
        }
        this.depthTexture = device.createTexture({
            size: [
                width,
                height
            ],
            format: "depth24plus",
            sampleCount: this.sampleCount,
            usage: GPUTextureUsage.RENDER_ATTACHMENT
        });
        this.depthTextureView = this.depthTexture.createView();
    }
    findOrCreateInstanceGroup(mesh, material) {
        for (const ig of this.instanceGroups){
            if (ig.mesh === mesh && ig.material === material) return ig;
        }
        const ig = new $7d54657999c4d04f$export$eb219d8a193c9434(mesh, material);
        this.instanceGroups.push(ig);
        return ig;
    }
    updateInstanceGroups() {
        for (const ig of this.instanceGroups)ig.prune();
        const outMat1 = new (0, $cbfe3793600821f0$export$c2c18cb318217958)();
        const outMat2 = new (0, $cbfe3793600821f0$export$c2c18cb318217958)();
        const update = (entity, worldTransform)=>{
            const renderComp = entity.components.get((0, $ccfb61ba2cf393a2$export$1746c996e5787f33));
            if (!renderComp) return;
            const transform = entity.components.get((0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0));
            if (!transform) return;
            const mesh = renderComp.mesh;
            const material = renderComp.material;
            if (renderComp.instanceGroup === null) {
                renderComp.instanceGroup = this.findOrCreateInstanceGroup(mesh, material);
                renderComp.instanceGroup.push(entity);
            }
            if (!renderComp.visible) {
                renderComp.instanceGroup.removeInstanceData(entity);
                return;
            }
            const finalInstanceData = {
                ...renderComp.instanceData
            };
            if (renderComp.material.getInstanceDataLayoutProperty("modelMatrix")?.type === "mat4f" && !finalInstanceData.hasOwnProperty("modelMatrix")) finalInstanceData["modelMatrix"] = (worldTransform === null ? transform.modelToWorld(outMat1) : worldTransform.mul(transform.modelToWorld(outMat1), outMat2)).clone().freeze();
            renderComp.instanceGroup.setInstanceData(entity, finalInstanceData);
        };
        const updateRec = (entity, worldTransform, forceUpdate)=>{
            const require = entity.components.get((0, $ccfb61ba2cf393a2$export$1746c996e5787f33))?.requireUpdate ?? false;
            if (forceUpdate || require) update(entity, worldTransform);
            if (entity.children.size === 0) return;
            const transform = entity.components.get((0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0));
            if (transform) worldTransform = worldTransform ? worldTransform.mul(transform.modelToWorld()) : transform.modelToWorld();
            for (const child of entity.children)updateRec(child, worldTransform, forceUpdate || require);
        };
        for (const entity of this.application.entities)updateRec(entity, null, false);
        for (const ig of this.instanceGroups)ig.upload();
    }
    render() {
        const cameraEntity = this.mainCamera;
        if (!cameraEntity) return;
        const device = this.device;
        this.resize();
        const cameraComponent = cameraEntity.components.unwrap_get((0, $ccfb61ba2cf393a2$export$fa441e75a97e4921));
        const clearColor = cameraComponent.clearColor;
        cameraComponent.aspect = this.canvas.width / this.canvas.height;
        const viewMatrix = cameraComponent.view();
        const projectionMatrix = cameraComponent.projection();
        const viewProjMatrix = projectionMatrix.mul(viewMatrix);
        this.device.queue.writeBuffer(this.sceneUniformsBuffer, 0, new Float32Array([
            ...viewProjMatrix.transpose().vals
        ]));
        const renderPassDescriptor = {
            colorAttachments: [
                {
                    view: this.renderTargetView ?? this.ctx.getCurrentTexture().createView(),
                    resolveTarget: this.renderTargetView !== null ? this.ctx.getCurrentTexture().createView() : undefined,
                    clearValue: clearColor ? {
                        r: clearColor.r,
                        g: clearColor.g,
                        b: clearColor.b,
                        a: clearColor.a
                    } : undefined,
                    loadOp: clearColor === null ? "load" : "clear",
                    storeOp: "store"
                }
            ],
            depthStencilAttachment: this.depthTextureView === null ? undefined : {
                view: this.depthTextureView,
                depthClearValue: 1,
                depthLoadOp: "clear",
                depthStoreOp: "store"
            }
        };
        this.updateInstanceGroups();
        const commandEncoder = device.createCommandEncoder();
        const passEncoder = commandEncoder.beginRenderPass(renderPassDescriptor);
        for (const ig of this.instanceGroups)ig.draw(passEncoder);
        passEncoder.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
    }
}



class $d4beea8bd1ddd725$export$16975c34e60e1e61 {
    #defered = [];
    #entities = new Set();
    canvas;
    renderer;
    totalTime = 0;
    dt = 0;
    statusBar;
    get entities() {
        return this.#entities;
    }
    static async create(canvas) {
        const app = new $d4beea8bd1ddd725$export$16975c34e60e1e61(canvas);
        app.renderer = await (0, $7d54657999c4d04f$export$88530751e3977073).create(app, canvas);
        return app;
    }
    constructor(canvas){
        this.canvas = canvas;
        const statusBar = document.getElementById("statusBar");
        if (statusBar === null || !(statusBar instanceof HTMLDivElement)) throw new (0, $6b0c0d5bde4dade9$export$3b14aa8c543ca7db)("Missing status bar element");
        this.statusBar = statusBar;
        // do not worry
        // shush
        this.renderer = null;
    }
    async start() {
        let onError = null;
        const promise = new Promise((_res, rej)=>{
            onError = rej;
        });
        let lastT = null;
        let animationFrame = null;
        const frame = (time)=>{
            try {
                if (lastT) this.update((0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)((time - lastT) / 1000, 0, 1 / 30));
                lastT = time;
                if (animationFrame != null) cancelAnimationFrame(animationFrame);
                if (!window.stopNow && !location.hash.includes("stopNow") && !(location.hash.includes("stop3s") && time > 3000)) animationFrame = requestAnimationFrame(frame);
            } catch (e) {
                onError?.(e);
            }
        };
        const resizeCanvas = ()=>{
            this.canvas.width = document.body.clientWidth;
            this.canvas.height = document.body.clientHeight;
            if (lastT) frame(lastT);
        };
        resizeCanvas();
        new ResizeObserver(resizeCanvas).observe(document.body);
        requestAnimationFrame(frame);
        return promise;
    }
    defer(cb) {
        this.#defered.push(cb);
    }
    spawn(entity) {
        if (this.#entities.has(entity)) throw new Error("entity already spawned");
        this.#entities.add(entity);
        entity.onSpawn();
    }
    despawn(entity) {
        if (this.#entities.delete(entity)) entity.onDespawn();
    }
    updateStatusBar() {
        let entityCount = 0;
        const count = (e)=>{
            entityCount++;
            e.children.forEach(count);
        };
        this.#entities.forEach(count);
        const text = `
      FPS: ${Math.round(1 / this.dt * 10) / 10}
      Entity count: ${entityCount}
      Draw calls: ${this.renderer.drawCallCount()}
    `.trim();
        if (this.statusBar.innerText !== text) this.statusBar.innerText = text;
    }
    update(dt) {
        this.totalTime += dt;
        this.dt = dt;
        this.#defered.forEach((cb)=>cb());
        this.#defered = [];
        for (const entity of this.#entities)entity.beforeUpdate();
        for (const entity of this.#entities)entity.update();
        this.updateStatusBar();
        this.renderer.render();
        for (const entity of this.#entities)entity.afterUpdate();
    }
}







var $75c1cd645385f986$exports = {};
$75c1cd645385f986$exports = "struct InstanceData {\n    modelMatrix: mat4x4f,\n    color: vec4f,\n}\n\nstruct Uniforms {\n    viewProjMatrix: mat4x4f,\n};\n\n@group(0) @binding(0) var<uniform> uniforms: Uniforms;\n@group(0) @binding(1) var<storage, read> instances: array<InstanceData>;\n\nstruct VertexOut {\n    @builtin(position) position: vec4f,\n    @location(0) worldPos: vec3f,\n    @location(1) normal: vec3f,\n    @location(2) uv: vec2f,\n    @location(3) color: vec4f,\n};\n \n@vertex\nfn vertex(\n    @builtin(instance_index) instanceIdx : u32,\n    @location(0) position: vec4f,\n    @location(1) normal: vec3f,\n    @location(2) uv: vec2f,\n) -> VertexOut {\n    let instance_data = instances[instanceIdx];\n\n    var out: VertexOut;\n    out.worldPos = (instance_data.modelMatrix * position).xyz;\n    out.position = (uniforms.viewProjMatrix * instance_data.modelMatrix) * position;\n    out.normal = (instance_data.modelMatrix * vec4(normal, 0.)).xyz;\n    out.uv = uv;\n    out.color = instance_data.color;\n    return out;\n}\n \n@fragment\nfn fragment(v: VertexOut) -> @location(0) vec4f {\n    // let to_light = normalize(v.worldPos.xyz - vec3f(0.));\n    // let lighting = dot(to_light, v.normal);\n    // return v.color * lighting;\n    return v.color;\n    // return vec4f((v.normal + 1.) / 2., 1.);\n}\n";


var $ef5d5cd9a6cd3af1$exports = {};
$ef5d5cd9a6cd3af1$exports = "struct InstanceData {\n    modelMatrix: mat4x4f,\n    color: vec4f,\n    normal: vec3f,\n}\n\nstruct Uniforms {\n    viewProjMatrix: mat4x4f,\n};\n\nconst LIGHT_POSITION: vec3f = vec3f(0., 1., 0.);\n\n@group(0) @binding(0) var<uniform> uniforms: Uniforms;\n@group(0) @binding(1) var<storage, read> instances: array<InstanceData>;\n\nstruct VertexOut {\n    @builtin(position) position: vec4f,\n    @location(0) worldPos: vec3f,\n    @location(1) normal: vec3f,\n    @location(2) uv: vec2f,\n    @location(3) color: vec4f,\n};\n \n@vertex\nfn vertex(\n    @builtin(instance_index) instanceIdx : u32,\n    @location(0) position: vec4f,\n    @location(1) normal: vec3f,\n    @location(2) uv: vec2f,\n) -> VertexOut {\n    let instance_data = instances[instanceIdx];\n\n    var out: VertexOut;\n    out.worldPos = (instance_data.modelMatrix * position).xyz;\n    out.normal = (instance_data.modelMatrix * vec4(normal, 0.)).xyz;\n    out.normal = (instance_data.modelMatrix * vec4(instance_data.normal, 0.)).xyz;\n\n    let to_light = out.worldPos.xyz - LIGHT_POSITION;\n    let lighting = dot(normalize(to_light), out.normal);\n\n    let scale: f32 = clamp(lighting, 0., 1.);\n    let scaling: mat4x4f = mat4x4f(\n        scale, 0., 0., 0.,\n        0., scale, 0., 0.,\n        0., 0., scale, 0.,\n        0., 0., 0.,    1.,\n    );\n\n    let newModelMat = instance_data.modelMatrix * scaling;\n\n    out.position = (uniforms.viewProjMatrix * newModelMat) * position;\n    out.uv = uv;\n    out.color = instance_data.color;\n    return out;\n}\n \n@fragment\nfn fragment(v: VertexOut) -> @location(0) vec4f {\n    // let to_light = normalize(v.worldPos.xyz - LIGHT_POSITION);\n    // let lighting = dot(to_light, v.normal);\n    // return vec4f(v.color.rgb * lighting * 2., v.color.a);\n    return v.color;\n    // return vec4f((v.normal + 1.) / 2., 1.);\n}\n";


var $3982efec1fb42f11$exports = {};
$3982efec1fb42f11$exports = "const PI = radians(180.0);\n\nfn lerp(fr: f32, to: f32, t: f32) -> f32 {\n    return fr * (1. - t) + to * t;\n}\n\nconst LIGHT_POSITION: vec3f = vec3f(0., 1., 0.);\nconst SHEET_BASE_HEIGHT: f32 = 0.25;\n\nstruct Uniforms {\n    totalTime: f32,\n    planeSize: f32,\n    particleCount: u32,\n    ballCount: u32,\n}\n\nstruct Particle {\n    position: vec3f,\n    radius: f32,\n}\n\n@group(0) @binding(0) var<storage, read_write> positions: array<f32>;\n@group(0) @binding(1) var<storage, read_write> normals: array<f32>;\n@group(0) @binding(2) var<storage, read_write> uvs: array<f32>;\n@group(0) @binding(3) var<uniform> uniforms: Uniforms;\n@group(0) @binding(4) var storageHeightMap: texture_storage_2d<r32float, read_write>;\n@group(0) @binding(5) var textureHeightMap: texture_2d<f32>;\n@group(0) @binding(6) var<storage, read> particles: array<Particle>;\n@group(0) @binding(7) var samplerHeightMap: sampler;\n@group(0) @binding(8) var<storage, read> ballPositions: array<vec3f>;\n@group(0) @binding(9) var<storage, read_write> ballLighting: array<f32>;\n\nfn getPos(i: u32) -> vec3f {\n    return vec3f(positions[i*3], positions[i*3+1], positions[i*3+2]);\n}\nfn setPos(i: u32, val: vec3f) {\n    positions[i*3] = val.x;\n    positions[i*3+1] = val.y;\n    positions[i*3+2] = val.z;\n}\n\nfn getNormal(i: u32) -> vec3f {\n    return vec3f(normals[i*3], normals[i*3+1], normals[i*3+2]);\n}\nfn setNormal(i: u32, val: vec3f) {\n    normals[i*3] = val.x;\n    normals[i*3+1] = val.y;\n    normals[i*3+2] = val.z;\n}\n\nfn getUv(i: u32) -> vec2f {\n    return vec2f(uvs[i*2], uvs[i*2+1]);\n}\n\nfn sampleHeight(uv: vec2f) -> f32 {\n    // let dims = textureDimensions(storageHeightMap);\n    // let actual = vec2(u32(uv.x * f32(dims.x)), u32(uv.y * f32(dims.y)));\n    // return textureLoad(storageHeightMap, actual).x;\n    return textureSampleLevel(textureHeightMap, samplerHeightMap, uv, 0.).r;\n}\n\nfn sampleHeightPos(pos: vec3f) -> f32 {\n    // let uv = (pos.xz - vec2f(uniforms.planeSize / 2.)) / vec2f(uniforms.planeSize);\n    let uv = (pos.xz + vec2f(uniforms.planeSize / 2.)) / vec2f(uniforms.planeSize);\n    return sampleHeight(uv);\n}\n\nfn displace_vertex(\n    i: u32\n) {\n    for (var di: u32 = 0; di < 3; di += 1) {\n        var pos = getPos(i+di);\n        pos.y = sampleHeight(getUv(i+di));\n        setPos(i+di, pos);\n    }\n\n    let a = getPos(i+0);\n    let b = getPos(i+1);\n    let c = getPos(i+2);\n\n    let A = b - a;\n    let B = c - a;\n    let N = normalize(cross(A, B));\n\n    for (var di: u32 = 0; di < 3; di += 1) {\n        setNormal(i+di, N);\n    }\n}\n \n// Move vertices based on texture\n@compute @workgroup_size(64) fn displace(\n    @builtin(global_invocation_id) global_invocation_id : vec3<u32>,\n) {\n    let index = global_invocation_id.x;\n\n    let vertexCount = arrayLength(&positions);\n    if (index >= vertexCount / 3) {\n        return;\n    }\n\n    displace_vertex(index * 3);\n}\n\nfn press_pixel(\n    pos: vec2<u32>\n) {\n    let dims = textureDimensions(storageHeightMap);\n    if (pos.x > dims.x || pos.y > dims.y) {\n        return;\n    }\n\n    let position = vec2f(\n        (f32(pos.x) / f32(dims.x)) * uniforms.planeSize - uniforms.planeSize/2.,\n        (f32(pos.y) / f32(dims.y)) * uniforms.planeSize - uniforms.planeSize/2.\n    );\n\n    for (var i: u32 = 0; i < uniforms.particleCount; i++) {\n        let dist = length(particles[i].position.xz - position);\n\n        let radius = particles[i].radius;\n\n        var height = 0.;\n        if (dist > radius) {\n            height = 99999.;\n        }\n        else {\n            height = -sqrt((radius * radius) - (dist * dist));\n        }\n        height = min(height, SHEET_BASE_HEIGHT);\n\n        let previousHeight = textureLoad(storageHeightMap, pos).x;\n        height = min(height, previousHeight);\n        textureStore(storageHeightMap, pos, vec4f(height));\n    }\n}\n\n// Make particles make an indent on the texture\n@compute @workgroup_size(16,16,1) fn press(\n    @builtin(global_invocation_id) global_invocation_id : vec3<u32>,\n) {\n    press_pixel(global_invocation_id.xy);\n}\n\nfn get_pixel_i32(\n    pos: vec2<i32>,\n    counted: ptr<function, bool>,\n) -> f32 {\n    let dims = textureDimensions(textureHeightMap);\n    if (pos.x < 0 || pos.y < 0 || pos.x > i32(dims.x) || pos.y > i32(dims.y)) {\n        *counted = false;\n        return 0.;\n    }\n    *counted = true;\n\n    return textureLoad(textureHeightMap, vec2u(pos), 0).x;\n}\n\nfn post_pixel(\n    pos: vec2<u32>\n) {\n    let dims = textureDimensions(storageHeightMap);\n    if (pos.x > dims.x || pos.y > dims.y) {\n        return;\n    }\n\n    let absoluteSpeed = 0.01;\n    let speed = absoluteSpeed / uniforms.planeSize;\n\n    let uv = (vec2f(pos) + 0.5) / vec2f(dims);\n    let targetUv = uv + (normalize(uv - 0.5) * -speed);\n    let val = sampleHeight(targetUv);\n\n    textureStore(storageHeightMap, pos, vec4f(val));\n}\n\n// Post processing of height map\n@compute @workgroup_size(16,16,1) fn post(\n    @builtin(global_invocation_id) global_invocation_id : vec3<u32>,\n) {\n    post_pixel(global_invocation_id.xy);\n}\n\nfn raySegmentIntersectsSphere(rayOrigin: vec3f, rayTarget: vec3f, sphereCenter: vec3f, sphereRadius: f32) -> bool {\n    let d = rayTarget - rayOrigin;\n    let f = rayOrigin - sphereCenter;\n\n    let a = dot(d, d);\n    let b = 2.0 * dot(f, d);\n    let c = dot(f, f) - sphereRadius * sphereRadius;\n\n    let discriminant = b * b - 4.0 * a * c;\n\n    if discriminant < 0.0 {\n        return false; // No intersection\n    }\n\n    let sqrtDiscriminant = sqrt(discriminant);\n    let t1 = (-b - sqrtDiscriminant) / (2.0 * a);\n    let t2 = (-b + sqrtDiscriminant) / (2.0 * a);\n\n    // Check if the intersection points are within the segment\n    if (t1 >= 0.0 && t1 <= 1.0) || (t2 >= 0.0 && t2 <= 1.0) {\n        return true;\n    }\n\n    return false;\n}\n\nfn lighting_at(pos: vec3f) -> f32 {\n    for (var iparticle: u32 = 0; iparticle < uniforms.particleCount; iparticle++) {\n        let particle: Particle = particles[iparticle];\n        if (raySegmentIntersectsSphere(pos, LIGHT_POSITION, particle.position, particle.radius)) {\n            return 0.;\n        }\n    }\n\n    let step_length = 0.1;\n    let to_light = LIGHT_POSITION - pos;\n    let distance_to_light = length(to_light);\n    let light_dir = to_light / distance_to_light;\n    let max_steps = min(1000, u32(distance_to_light / step_length));\n\n    var current_pos = pos;\n    for (var steps: u32 = 0; steps < max_steps; steps++) {\n        current_pos += light_dir * step_length;\n        let nh = sampleHeightPos(current_pos);\n        let diff = current_pos.y - nh;\n        if diff > 0. {\n            continue;\n        }\n\n        return 0.;\n    }\n\n    let f = distance_to_light / (uniforms.planeSize / 2.);\n    return pow(1. - f, 1.8);\n}\n\nfn lighting_for(i: u32) {\n    let pos = vec3f(\n        ballPositions[i].x,\n        sampleHeightPos(ballPositions[i]),\n        ballPositions[i].z\n    );\n\n    var sum = 0.;\n    for (var dx: i32 = -2; dx <= 2; dx++) {\n        for (var dy: i32 = -2; dy <= 2; dy++) {\n            sum += lighting_at(pos + vec3f(f32(dx) * 0.05, 0., f32(dy) * 0.05));\n        }\n    }\n    ballLighting[i] = sum / 25.;\n}\n\n// Compute light level for each balls\n@compute @workgroup_size(64,1,1) fn lighting(\n    @builtin(global_invocation_id) global_invocation_id : vec3<u32>,\n) {\n    lighting_for(global_invocation_id.x);\n}\n";


var $a70cb1aa411f8c85$exports = {};
$a70cb1aa411f8c85$exports = "struct InstanceData {\n    modelMatrix: mat4x4f,\n    color: vec4f,\n    ballIndex: u32,\n}\n\nstruct Uniforms {\n    viewProjMatrix: mat4x4f,\n};\n\n@group(0) @binding(0) var<uniform> uniforms: Uniforms;\n@group(0) @binding(1) var<storage, read> instances: array<InstanceData>;\n@group(1) @binding(0) var textureHeightMap: texture_2d<f32>;\n@group(1) @binding(1) var samplerHeightMap: sampler;\n@group(1) @binding(2) var<storage, read> ballLighting: array<f32>;\n\nstruct VertexOut {\n    @builtin(position) position: vec4f,\n    @location(0) worldPos: vec3f,\n    @location(1) normal: vec3f,\n    @location(2) uv: vec2f,\n    @location(3) color: vec4f,\n};\n \n@vertex\nfn vertex(\n    @builtin(instance_index) instanceIdx : u32,\n    @location(0) position: vec4f,\n    @location(1) normal: vec3f,\n    @location(2) uv: vec2f,\n) -> VertexOut {\n    let instance_data = instances[instanceIdx];\n\n    let actual_pos = instance_data.modelMatrix * vec4f(0., 0., 0., 1.);\n\n    let scale = ballLighting[instance_data.ballIndex];\n    let scaling: mat4x4f = mat4x4f(\n        scale, 0., 0., 0.,\n        0., scale, 0., 0.,\n        0., 0., scale, 0.,\n        0., 0., 0.,    1.,\n    );\n\n    var out: VertexOut;\n\n    out.worldPos = (instance_data.modelMatrix * scaling * position).xyz;\n    let plane_uv = (actual_pos.xz + 10.) / 20.;\n    out.worldPos.y += textureSampleLevel(textureHeightMap, samplerHeightMap, plane_uv, 0.).r;\n\n    out.position = uniforms.viewProjMatrix * vec4f(out.worldPos, 1.);\n\n    out.normal = (instance_data.modelMatrix * vec4(normal, 0.)).xyz;\n    out.uv = uv;\n    out.color = instance_data.color;\n    return out;\n}\n \n@fragment\nfn fragment(v: VertexOut) -> @location(0) vec4f {\n    // let to_light = normalize(v.worldPos.xyz - LIGHT_POSITION);\n    // let lighting = dot(to_light, v.normal);\n    // return vec4f(v.color.rgb * lighting, v.color.a);\n    return v.color;\n    // return vec4f((v.normal + 1.) / 2., 1.);\n}\n";




class $ab954773b21afa15$export$e176487c05830cc5 {
    renderer;
    positionsBuffer;
    normalsBuffer;
    uvsBuffer;
    constructor(renderer, positionsBuffer, normalsBuffer, uvsBuffer){
        this.renderer = renderer;
        this.positionsBuffer = positionsBuffer;
        this.normalsBuffer = normalsBuffer;
        this.uvsBuffer = uvsBuffer;
    }
    static fromVertices(renderer, { positions: positions, normals: normals, uvs: uvs }) {
        const device = renderer.device;
        const positionsBuffer = device.createBuffer({
            size: positions.length * 4,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.STORAGE,
            mappedAtCreation: true
        });
        new Float32Array(positionsBuffer.getMappedRange()).set(positions);
        positionsBuffer.unmap();
        const normalsBuffer = device.createBuffer({
            size: normals.length * 4,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.STORAGE,
            mappedAtCreation: true
        });
        new Float32Array(normalsBuffer.getMappedRange()).set(normals);
        normalsBuffer.unmap();
        const uvsBuffer = device.createBuffer({
            size: uvs.length * 4,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.STORAGE,
            mappedAtCreation: true
        });
        new Float32Array(uvsBuffer.getMappedRange()).set(uvs);
        uvsBuffer.unmap();
        return new $ab954773b21afa15$export$e176487c05830cc5(renderer, positionsBuffer, normalsBuffer, uvsBuffer);
    }
    static planeVertices(subdivs, size) {
        if (subdivs < 0) throw new RangeError("Subdivs mush be positive");
        const vertexCountForSubdivs0 = 6;
        const vertexCount = vertexCountForSubdivs0 * (subdivs + 1) ** 2;
        const positions = new Float32Array(vertexCount * 3);
        const normals = new Float32Array(vertexCount * 3);
        const uvs = new Float32Array(vertexCount * 2);
        let positionPointer = 0;
        let normalPointer = 0;
        let uvPointer = 0;
        function pushVertex(x, y, z, u, v) {
            positions[positionPointer++] = x;
            positions[positionPointer++] = y;
            positions[positionPointer++] = z;
            normals[normalPointer++] = 0;
            normals[normalPointer++] = 0;
            normals[normalPointer++] = 0;
            uvs[uvPointer++] = u;
            uvs[uvPointer++] = v;
        }
        const sideValues = [
            [
                0,
                1
            ],
            [
                1,
                0
            ],
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                0,
                1
            ],
            [
                1,
                1
            ]
        ];
        function swap() {
            [sideValues[0], sideValues[2]] = [
                sideValues[2],
                sideValues[0]
            ];
            [sideValues[3], sideValues[5]] = [
                sideValues[5],
                sideValues[3]
            ];
        }
        swap();
        for(let subdivX = 0; subdivX <= subdivs; subdivX++){
            for(let subdivY = 0; subdivY <= subdivs; subdivY++)for (const sv of sideValues){
                const rx = (sv[0] + subdivX) / (subdivs + 1);
                const ry = (sv[1] + subdivY) / (subdivs + 1);
                pushVertex((rx - 0.5) * size, 0., (ry - 0.5) * size, rx, ry);
            }
        }
        return {
            positions: positions,
            normals: normals,
            uvs: uvs
        };
    }
    /// Subdivs at 0 = normal cube
    static cubeVertices(subdivs) {
        if (subdivs < 0) throw new RangeError("Subdivs mush be positive");
        const vertexCountPerSideForSubdivs0 = 6;
        const vertexCountPerSide = vertexCountPerSideForSubdivs0 * (subdivs + 1) ** 2;
        const vertexCount = vertexCountPerSide * 6;
        const positions = new Float32Array(vertexCount * 3);
        const normals = new Float32Array(vertexCount * 3);
        const uvs = new Float32Array(vertexCount * 2);
        let positionPointer = 0;
        let normalPointer = 0;
        let uvPointer = 0;
        function pushVertex(x, y, z, u, v) {
            positions[positionPointer++] = x;
            positions[positionPointer++] = y;
            positions[positionPointer++] = z;
            normals[normalPointer++] = 0;
            normals[normalPointer++] = 0;
            normals[normalPointer++] = 0;
            uvs[uvPointer++] = u;
            uvs[uvPointer++] = v;
        }
        for(let axis = 0; axis < 3; axis++){
            const sideValues = [
                [
                    0,
                    1
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    0
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    1,
                    1
                ]
            ];
            function swap() {
                [sideValues[0], sideValues[2]] = [
                    sideValues[2],
                    sideValues[0]
                ];
                [sideValues[3], sideValues[5]] = [
                    sideValues[5],
                    sideValues[3]
                ];
            }
            if (axis !== 1) swap();
            for(let thirdAxisVal = 0; thirdAxisVal <= 1; thirdAxisVal++){
                if (thirdAxisVal === 1) swap();
                for(let subdivX = 0; subdivX <= subdivs; subdivX++){
                    for(let subdivY = 0; subdivY <= subdivs; subdivY++)for (const sv of sideValues){
                        const rx = (sv[0] + subdivX) / (subdivs + 1);
                        const ry = (sv[1] + subdivY) / (subdivs + 1);
                        if (axis === 0) pushVertex(thirdAxisVal - 0.5, rx - 0.5, ry - 0.5, rx, ry);
                        if (axis === 1) pushVertex(rx - 0.5, thirdAxisVal - 0.5, ry - 0.5, rx, ry);
                        if (axis === 2) pushVertex(rx - 0.5, ry - 0.5, thirdAxisVal - 0.5, rx, ry);
                    }
                }
            }
        }
        return {
            positions: positions,
            normals: normals,
            uvs: uvs
        };
    }
    static normalizeVertices(vertices, radius = 1) {
        for(let i = 0; i < vertices.positions.length; i += 3){
            const ax = vertices.positions[i + 0];
            const ay = vertices.positions[i + 1];
            const az = vertices.positions[i + 2];
            const fact = radius / Math.sqrt(ax ** 2 + ay ** 2 + az ** 2);
            vertices.positions[i + 0] *= fact;
            vertices.positions[i + 1] *= fact;
            vertices.positions[i + 2] *= fact;
        }
    }
    static computeNormals(vertices) {
        // not using vertors classes for speed reasons
        for(let i = 0; i < vertices.positions.length / 3; i += 3){
            const ax = vertices.positions[(i + 0) * 3 + 0];
            const ay = vertices.positions[(i + 0) * 3 + 1];
            const az = vertices.positions[(i + 0) * 3 + 2];
            const bx = vertices.positions[(i + 1) * 3 + 0];
            const by = vertices.positions[(i + 1) * 3 + 1];
            const bz = vertices.positions[(i + 1) * 3 + 2];
            const cx = vertices.positions[(i + 2) * 3 + 0];
            const cy = vertices.positions[(i + 2) * 3 + 1];
            const cz = vertices.positions[(i + 2) * 3 + 2];
            const Ax = bx - ax;
            const Ay = by - ay;
            const Az = bz - az;
            const Bx = cx - ax;
            const By = cy - ay;
            const Bz = cz - az;
            let Nx = Ay * Bz - Az * By;
            let Ny = Az * Bx - Ax * Bz;
            let Nz = Ax * By - Ay * Bx;
            const length = Math.sqrt(Nx ** 2 + Ny ** 2 + Nz ** 2);
            Nx /= length;
            Ny /= length;
            Nz /= length;
            for(let v = 0; v < 3; v++){
                vertices.normals[(i + v) * 3 + 0] = Nx;
                vertices.normals[(i + v) * 3 + 1] = Ny;
                vertices.normals[(i + v) * 3 + 2] = Nz;
            }
        }
    }
    clean() {
        this.normalsBuffer.destroy();
        this.uvsBuffer.destroy();
        this.positionsBuffer.destroy();
    }
}


class $b4e14b6b8da86996$export$13ab4806c153ec0b extends (0, $b5ab58a39619b6e0$export$16fa2f45be04daa8) {
    mass = 1;
    withMass(mass) {
        this.mass = mass;
        return this;
    }
}
class $b4e14b6b8da86996$export$9928f100558c1566 extends (0, $b5ab58a39619b6e0$export$16fa2f45be04daa8) {
    position = (0, $c3a2047b9f740e67$export$838423f3adec30fa).ZERO;
    velocity = (0, $c3a2047b9f740e67$export$838423f3adec30fa).ZERO;
    radius = 0.5;
    withVelocity(vel) {
        this.velocity = vel;
        return this;
    }
    start() {
        super.start();
        const transform = this.entity.components.unwrap_get((0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0));
        this.position = transform.translation;
    }
    update() {
        super.update();
        const dt = this.application.dt;
        const transform = this.entity.components.unwrap_get((0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0));
        let force = (0, $c3a2047b9f740e67$export$838423f3adec30fa).ZERO;
        for (const entity of this.application.entities){
            if (entity === this.entity) continue;
            const other_particle = entity.components.get($b4e14b6b8da86996$export$9928f100558c1566);
            if (!other_particle) continue;
            const other_mass = entity.components.get($b4e14b6b8da86996$export$13ab4806c153ec0b);
            if (!other_mass) continue;
            const diff = other_particle.position.sub(this.position);
            const dist = diff.norm();
            const dir = diff.div(dist);
            // let actualDist = clamp(dist, this.radius/2, null);
            force = force.add(dir.mul(other_mass.mass / (dist * dist))).as_vec3();
        }
        this.velocity = this.velocity.add(force.mul(dt)).as_vec3();
        transform.globalRotateZ(-(this.velocity.x / this.radius) * dt);
        transform.globalRotateX(this.velocity.z / this.radius * dt);
        transform.translation = this.position;
    }
    afterUpdate() {
        const dt = this.application.dt;
        this.position = this.position.add(this.velocity.mul(dt).as_vec3()).as_vec3();
    }
}
class $b4e14b6b8da86996$export$593d744a5fc1c0a8 extends (0, $b5ab58a39619b6e0$export$16fa2f45be04daa8) {
    update() {
        super.update();
        const dt = this.application.dt;
        const transform = this.entity.components.unwrap_get((0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0));
        transform.translation = (0, $cbfe3793600821f0$export$83f4edd572c84121).rotateY(dt).mul(transform.translation);
        transform.affine = (0, $cbfe3793600821f0$export$83f4edd572c84121).looking_at(transform.translation, (0, $c3a2047b9f740e67$export$838423f3adec30fa).ZERO, (0, $c3a2047b9f740e67$export$838423f3adec30fa).UP);
    }
}
class $b4e14b6b8da86996$export$bcf87d11d46ea94f extends (0, $b5ab58a39619b6e0$export$16fa2f45be04daa8) {
    planeSize;
    planeSubdivs;
    renderer;
    mesh;
    ballMaterial;
    computeShaderModule;
    uniform;
    particlesBuffer;
    particlesArray;
    ballList;
    ballPositionsBuffer;
    ballLightingBuffer;
    pipelines;
    heightmapPre;
    heightmapPost;
    heightmapSampler;
    particleDataSize;
    constructor(entity, planeSize, planeSubdivs, textureSize){
        super(entity);
        this.planeSize = planeSize;
        this.planeSubdivs = planeSubdivs;
        this.ballList = [];
        this.pipelines = null;
        this.particleDataSize = 16;
        this.mesh = entity.components.unwrap_get((0, $ccfb61ba2cf393a2$export$1746c996e5787f33)).mesh;
        this.renderer = entity.application.renderer;
        const device = this.renderer.device;
        this.computeShaderModule = device.createShaderModule({
            code: (0, (/*@__PURE__*/$parcel$interopDefault($3982efec1fb42f11$exports)))
        });
        this.uniform = device.createBuffer({
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            size: 16
        });
        this.heightmapPre = device.createTexture({
            label: "heightMap pre",
            format: "r32float",
            size: [
                textureSize,
                textureSize
            ],
            usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING
        });
        this.heightmapPost = device.createTexture({
            label: "heightMap post",
            format: "r32float",
            size: [
                textureSize,
                textureSize
            ],
            usage: GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST | GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING
        });
        this.heightmapSampler = device.createSampler({
            label: "heightMapSamper",
            minFilter: "linear",
            magFilter: "linear",
            // minFilter: "nearest",
            // magFilter: "nearest",
            addressModeU: "clamp-to-edge",
            addressModeV: "clamp-to-edge"
        });
        device.queue.writeTexture({
            texture: this.heightmapPost
        }, new Float32Array(textureSize ** 2).fill(Infinity), {
            bytesPerRow: textureSize * 4
        }, [
            textureSize,
            textureSize
        ]);
        const particleCapacity = 100;
        this.particlesArray = new Float32Array(particleCapacity * (this.particleDataSize / 4));
        this.particlesBuffer = device.createBuffer({
            size: this.particleDataSize * particleCapacity,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.STORAGE
        });
        this.ballPositionsBuffer = device.createBuffer({
            label: "ball lighting buffer",
            size: 0,
            usage: GPUBufferUsage.STORAGE
        });
        this.ballLightingBuffer = device.createBuffer({
            label: "ball lighting buffer",
            size: 0,
            usage: GPUBufferUsage.STORAGE
        });
        this.ballMaterial = (0, $86dc84cddbb87a35$export$a2d8b23205c25948).fromSource(this.renderer, (0, (/*@__PURE__*/$parcel$interopDefault($a70cb1aa411f8c85$exports))), {
            properties: [
                {
                    name: "modelMatrix",
                    type: "mat4f"
                },
                {
                    name: "color",
                    type: "vec4f"
                },
                {
                    name: "ballIndex",
                    type: "u32"
                },
                {
                    name: "pad1",
                    type: "u32"
                },
                {
                    name: "pad2",
                    type: "u32"
                },
                {
                    name: "pad3",
                    type: "u32"
                }
            ]
        });
    }
    start() {
        const device = this.renderer.device;
        this.ballList = [
            ...this.entity.children
        ];
        this.ballPositionsBuffer.destroy();
        this.ballPositionsBuffer = device.createBuffer({
            label: "ball positions buffer",
            size: 16 * this.ballList.length,
            usage: GPUBufferUsage.STORAGE,
            mappedAtCreation: true
        });
        const mapped = this.ballPositionsBuffer.getMappedRange();
        const array = new Float32Array(mapped);
        this.ballList.forEach((ball, i)=>{
            ball.components.unwrap_get((0, $ccfb61ba2cf393a2$export$1746c996e5787f33)).withInstanceData("ballIndex", i);
            const trans = ball.components.unwrap_get((0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0));
            array[i * 4 + 0] = trans.translation.x;
            array[i * 4 + 1] = trans.translation.y;
            array[i * 4 + 2] = trans.translation.z;
        });
        this.ballPositionsBuffer.unmap();
        this.ballLightingBuffer.destroy();
        this.ballLightingBuffer = device.createBuffer({
            label: "ball lighting buffer",
            size: 4 * this.ballList.length,
            usage: GPUBufferUsage.STORAGE
        });
        this.pipelines = null;
    }
    updatePipelines() {
        const device = this.renderer.device;
        const pipelines = {};
        const pressPipeline = device.createComputePipeline({
            layout: "auto",
            label: "sheet press compute pipeline",
            compute: {
                module: this.computeShaderModule,
                entryPoint: "press"
            }
        });
        const pressBindgroup = device.createBindGroup({
            layout: pressPipeline.getBindGroupLayout(0),
            label: "press sheet bind group",
            entries: [
                // { binding: 0, resource: { buffer: this.mesh.positionsBuffer } },
                // { binding: 1, resource: { buffer: this.mesh.normalsBuffer } },
                // { binding: 2, resource: { buffer: this.mesh.uvsBuffer } },
                {
                    binding: 3,
                    resource: {
                        buffer: this.uniform
                    }
                },
                {
                    binding: 4,
                    resource: this.heightmapPre.createView()
                },
                // { binding: 5, resource: this.heightmapPost.createView() },
                {
                    binding: 6,
                    resource: {
                        buffer: this.particlesBuffer
                    }
                }
            ]
        });
        pipelines.press = {
            bindgroup: pressBindgroup,
            pipeline: pressPipeline
        };
        const postPipeline = device.createComputePipeline({
            layout: "auto",
            label: "sheet post compute pipeline",
            compute: {
                module: this.computeShaderModule,
                entryPoint: "post"
            }
        });
        const postBindgroup = device.createBindGroup({
            layout: postPipeline.getBindGroupLayout(0),
            label: "post sheet bind group",
            entries: [
                // { binding: 0, resource: { buffer: this.mesh.positionsBuffer } },
                // { binding: 1, resource: { buffer: this.mesh.normalsBuffer } },
                // { binding: 2, resource: { buffer: this.mesh.uvsBuffer } },
                {
                    binding: 3,
                    resource: {
                        buffer: this.uniform
                    }
                },
                {
                    binding: 4,
                    resource: this.heightmapPost.createView()
                },
                {
                    binding: 5,
                    resource: this.heightmapPre.createView()
                },
                // { binding: 6, resource: { buffer: this.particlesBuffer } },
                {
                    binding: 7,
                    resource: this.heightmapSampler
                }
            ]
        });
        pipelines.post = {
            pipeline: postPipeline,
            bindgroup: postBindgroup
        };
        const displacePipeline = device.createComputePipeline({
            layout: "auto",
            label: "sheet displace compute pipeline",
            compute: {
                module: this.computeShaderModule,
                entryPoint: "displace"
            }
        });
        const displaceBindgroup = device.createBindGroup({
            layout: displacePipeline.getBindGroupLayout(0),
            label: "displace sheet bind group",
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.mesh.positionsBuffer
                    }
                },
                {
                    binding: 1,
                    resource: {
                        buffer: this.mesh.normalsBuffer
                    }
                },
                {
                    binding: 2,
                    resource: {
                        buffer: this.mesh.uvsBuffer
                    }
                },
                // { binding: 3, resource: { buffer: this.uniform } },
                // { binding: 4, resource: this.heightmapPre.createView() },
                {
                    binding: 5,
                    resource: this.heightmapPost.createView()
                },
                // { binding: 6, resource: { buffer: this.particlesBuffer } },
                {
                    binding: 7,
                    resource: this.heightmapSampler
                }
            ]
        });
        pipelines.displace = {
            pipeline: displacePipeline,
            bindgroup: displaceBindgroup
        };
        const ballLightingPipeline = device.createComputePipeline({
            layout: "auto",
            label: "sheet lighting compute pipeline",
            compute: {
                module: this.computeShaderModule,
                entryPoint: "lighting"
            }
        });
        const ballLightingBindgroup = device.createBindGroup({
            layout: ballLightingPipeline.getBindGroupLayout(0),
            label: "lighting sheet bind group",
            entries: [
                // { binding: 0, resource: { buffer: this.mesh.positionsBuffer } },
                // { binding: 1, resource: { buffer: this.mesh.normalsBuffer } },
                // { binding: 2, resource: { buffer: this.mesh.uvsBuffer } },
                {
                    binding: 3,
                    resource: {
                        buffer: this.uniform
                    }
                },
                // { binding: 5, resource: this.heightmapPre.createView() },
                {
                    binding: 5,
                    resource: this.heightmapPost.createView()
                },
                {
                    binding: 6,
                    resource: {
                        buffer: this.particlesBuffer
                    }
                },
                {
                    binding: 7,
                    resource: this.heightmapSampler
                },
                {
                    binding: 8,
                    resource: {
                        buffer: this.ballPositionsBuffer
                    }
                },
                {
                    binding: 9,
                    resource: {
                        buffer: this.ballLightingBuffer
                    }
                }
            ]
        });
        pipelines.ballLighting = {
            pipeline: ballLightingPipeline,
            bindgroup: ballLightingBindgroup
        };
        this.ballMaterial.customBindGroups = [
            {
                bg: device.createBindGroup({
                    layout: this.ballMaterial.pipeline.getBindGroupLayout(1),
                    entries: [
                        {
                            binding: 0,
                            resource: this.heightmapPost.createView()
                        },
                        {
                            binding: 1,
                            resource: this.heightmapSampler
                        },
                        {
                            binding: 2,
                            resource: {
                                buffer: this.ballLightingBuffer
                            }
                        }
                    ]
                }),
                target: 1
            }
        ];
        this.pipelines = pipelines;
    }
    update() {
        const device = this.renderer.device;
        let particleCount = 0;
        for (const entity of this.application.entities){
            const particle = entity.components.get($b4e14b6b8da86996$export$9928f100558c1566);
            if (!particle) continue;
            const transform = entity.components.unwrap_get((0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0));
            this.particlesArray.set([
                ...transform.translation.vals,
                particle.radius
            ], particleCount * (this.particleDataSize / 4));
            particleCount += 1;
        }
        device.queue.writeBuffer(this.particlesBuffer, 0, this.particlesArray);
        device.queue.writeBuffer(this.uniform, 0, new Float32Array([
            this.application.totalTime,
            this.planeSize
        ]));
        device.queue.writeBuffer(this.uniform, 8, new Uint32Array([
            particleCount,
            this.ballList.length
        ]));
        if (!this.pipelines) this.updatePipelines();
        const pipelines = this.pipelines;
        if (!pipelines) throw new Error("no pipelines?");
        const commandEncoder = device.createCommandEncoder();
        commandEncoder.copyTextureToTexture({
            texture: this.heightmapPost
        }, {
            texture: this.heightmapPre
        }, [
            this.heightmapPre.width,
            this.heightmapPre.height
        ]);
        const passEncoder = commandEncoder.beginComputePass();
        passEncoder.setPipeline(pipelines.press.pipeline);
        passEncoder.setBindGroup(0, pipelines.press.bindgroup);
        passEncoder.dispatchWorkgroups(this.heightmapPre.width / 16, this.heightmapPre.height / 16, 1);
        passEncoder.setPipeline(pipelines.post.pipeline);
        passEncoder.setBindGroup(0, pipelines.post.bindgroup);
        passEncoder.dispatchWorkgroups(this.heightmapPre.width / 16, this.heightmapPre.height / 16, 1);
        const count = this.mesh.positionsBuffer.size / 12;
        passEncoder.setPipeline(pipelines.displace.pipeline);
        passEncoder.setBindGroup(0, pipelines.displace.bindgroup);
        passEncoder.dispatchWorkgroups(count / 3 / 64, 1, 1);
        passEncoder.setPipeline(pipelines.ballLighting.pipeline);
        passEncoder.setBindGroup(0, pipelines.ballLighting.bindgroup);
        passEncoder.dispatchWorkgroups(this.ballList.length / 64);
        passEncoder.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
    }
}
const $b4e14b6b8da86996$var$run = async ()=>{
    const canvas = document.getElementById("canvas");
    if (!canvas || !(canvas instanceof HTMLCanvasElement)) throw new Error("no");
    const app = await (0, $d4beea8bd1ddd725$export$16975c34e60e1e61).create(canvas);
    const camera = new (0, $b5ab58a39619b6e0$export$bc644a473284d944)(app);
    camera.addComponent(new (0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0)(camera).rotateX(-0.2).translate(new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(0, 8, 10)).lookAt((0, $c3a2047b9f740e67$export$838423f3adec30fa).ZERO));
    camera.addComponent(new (0, $ccfb61ba2cf393a2$export$fa441e75a97e4921)(camera).withClearColor(new (0, $cdf9471f9e6d285f$export$892596cec99bc70e)(0., 0., 0., 1)));
    // camera.addComponent(new LookAroundComponent(camera));
    app.spawn(camera);
    app.renderer.mainCamera = camera;
    const material = (0, $86dc84cddbb87a35$export$a2d8b23205c25948).fromSource(app.renderer, (0, (/*@__PURE__*/$parcel$interopDefault($75c1cd645385f986$exports))), {
        properties: [
            {
                name: "modelMatrix",
                type: "mat4f"
            },
            {
                name: "color",
                type: "vec4f"
            }
        ]
    });
    const ballMaterial = (0, $86dc84cddbb87a35$export$a2d8b23205c25948).fromSource(app.renderer, (0, (/*@__PURE__*/$parcel$interopDefault($ef5d5cd9a6cd3af1$exports))), {
        properties: [
            {
                name: "modelMatrix",
                type: "mat4f"
            },
            {
                name: "color",
                type: "vec4f"
            },
            {
                name: "normal",
                type: "vec3f"
            },
            {
                name: "padding",
                type: "f32"
            }
        ]
    });
    let sphereMesh;
    {
        console.log("CREATING SPHERE");
        console.time("vertices");
        const vertices = (0, $ab954773b21afa15$export$e176487c05830cc5).cubeVertices(10);
        console.timeEnd("vertices");
        console.log("vertex count:", vertices.positions.length / 3);
        console.time("normalize");
        (0, $ab954773b21afa15$export$e176487c05830cc5).normalizeVertices(vertices, 0.5);
        console.timeEnd("normalize");
        console.time("computeNormals");
        (0, $ab954773b21afa15$export$e176487c05830cc5).computeNormals(vertices);
        console.timeEnd("computeNormals");
        sphereMesh = (0, $ab954773b21afa15$export$e176487c05830cc5).fromVertices(app.renderer, vertices);
    }
    let smallSphereMesh;
    {
        console.log("CREATING SPHERE");
        console.time("vertices");
        const vertices = (0, $ab954773b21afa15$export$e176487c05830cc5).cubeVertices(2);
        console.timeEnd("vertices");
        console.log("vertex count:", vertices.positions.length / 3);
        console.time("normalize");
        // Mesh.normalizeVertices(vertices, 0.03);
        (0, $ab954773b21afa15$export$e176487c05830cc5).normalizeVertices(vertices, 0.05);
        console.timeEnd("normalize");
        console.time("computeNormals");
        (0, $ab954773b21afa15$export$e176487c05830cc5).computeNormals(vertices);
        console.timeEnd("computeNormals");
        smallSphereMesh = (0, $ab954773b21afa15$export$e176487c05830cc5).fromVertices(app.renderer, vertices);
    }
    const ballMass = 70;
    const ballDistance = 4;
    const ballSpeed = 2;
    const spawnBall = (pos, velocity)=>{
        const sphereEntity = new (0, $b5ab58a39619b6e0$export$bc644a473284d944)(app);
        sphereEntity.addComponent(new (0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0)(sphereEntity).translate(pos));
        sphereEntity.addComponent(new (0, $ccfb61ba2cf393a2$export$1746c996e5787f33)(sphereEntity, sphereMesh, material).withInstanceData("color", (0, $cdf9471f9e6d285f$export$892596cec99bc70e).BLACK));
        sphereEntity.addComponent(new $b4e14b6b8da86996$export$9928f100558c1566(sphereEntity).withVelocity(velocity));
        sphereEntity.addComponent(new $b4e14b6b8da86996$export$13ab4806c153ec0b(sphereEntity).withMass(ballMass));
        const radius = 0.5;
        const n = 150;
        // Function to convert spherical coordinates to Cartesian coordinates
        const sphericalToCartesian = (r, theta, phi)=>{
            return new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(r * Math.sin(theta) * Math.cos(phi), r * Math.sin(theta) * Math.sin(phi), r * Math.cos(theta));
        };
        // Add n evenly spaced small balls on the surface
        for(let i = 0; i < n; i++){
            // Calculate theta and phi for evenly distributed points
            const theta = Math.acos(1 - 2 * (i + 0.5) / n); // θ is the polar angle
            const phi = Math.PI * (1 + Math.sqrt(5)) * (i + 0.5); // φ is the azimuthal angle
            const smallBallPos = sphericalToCartesian(radius, theta, phi).as_vec3();
            const normal = sphericalToCartesian(-1, theta, phi).normalize().as_vec3();
            const smallBall = new (0, $b5ab58a39619b6e0$export$bc644a473284d944)(app);
            smallBall.addComponent(new (0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0)(smallBall).translate(smallBallPos));
            smallBall.addComponent(new (0, $ccfb61ba2cf393a2$export$1746c996e5787f33)(smallBall, smallSphereMesh, ballMaterial).withInstanceData("color", (0, $cdf9471f9e6d285f$export$892596cec99bc70e).WHITE).withInstanceData("normal", normal));
            sphereEntity.children.add(smallBall);
        }
        app.spawn(sphereEntity);
    };
    const ballCount = 3;
    for(let balli = 0; balli < ballCount; balli++){
        const rotate = (0, $cbfe3793600821f0$export$83f4edd572c84121).rotateY(balli / ballCount * Math.PI * 2);
        spawnBall(rotate.mul(new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(0, 0, ballDistance)), rotate.mul(new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(ballSpeed, 0, 0)));
    }
    const planeSize = 20;
    const planeSubdivs = 200;
    const planeTextureSize = 400;
    let planeMesh;
    {
        console.log("CREATING PLANE");
        console.time("vertices");
        const vertices = (0, $ab954773b21afa15$export$e176487c05830cc5).planeVertices(planeSubdivs, planeSize);
        console.timeEnd("vertices");
        console.log("vertex count:", vertices.positions.length / 3);
        console.time("computeNormals");
        (0, $ab954773b21afa15$export$e176487c05830cc5).computeNormals(vertices);
        console.timeEnd("computeNormals");
        planeMesh = (0, $ab954773b21afa15$export$e176487c05830cc5).fromVertices(app.renderer, vertices);
    }
    const planeEntity = new (0, $b5ab58a39619b6e0$export$bc644a473284d944)(app);
    planeEntity.addComponent(new (0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0)(planeEntity));
    planeEntity.addComponent(new (0, $ccfb61ba2cf393a2$export$1746c996e5787f33)(planeEntity, planeMesh, material).withInstanceData("color", new (0, $cdf9471f9e6d285f$export$892596cec99bc70e)(0., 0., 0., 1.)));
    const sheetComp = new $b4e14b6b8da86996$export$bcf87d11d46ea94f(planeEntity, planeSize, planeSubdivs, planeTextureSize);
    planeEntity.addComponent(sheetComp);
    const ballSep = 0.1;
    for(let x = -planeSize / 2; x < planeSize / 2; x += ballSep)for(let y = -planeSize / 2; y < planeSize / 2; y += ballSep){
        const smallBallPos = new (0, $c3a2047b9f740e67$export$838423f3adec30fa)(x, 0, y);
        if (smallBallPos.norm() > planeSize / 2.5) continue;
        const smallBall = new (0, $b5ab58a39619b6e0$export$bc644a473284d944)(app);
        smallBall.addComponent(new (0, $ccfb61ba2cf393a2$export$1def2aa75b7c7fe0)(smallBall).translate(smallBallPos));
        smallBall.addComponent(new (0, $ccfb61ba2cf393a2$export$1746c996e5787f33)(smallBall, smallSphereMesh, sheetComp.ballMaterial).withInstanceData("color", (0, $cdf9471f9e6d285f$export$892596cec99bc70e).WHITE));
        planeEntity.children.add(smallBall);
    }
    app.spawn(planeEntity);
    await app.start();
};
(async ()=>{
    try {
        await $b4e14b6b8da86996$var$run();
    } catch (e) {
        console.error(e);
        document.body.innerHTML = `<div class="error"></div>`;
        const el = document.createElement("div");
        if (e instanceof (0, $6b0c0d5bde4dade9$export$3b14aa8c543ca7db)) el.innerText = `User Error ! : ${e.message}`;
        else if (e instanceof Error) el.innerText = `${e.name} ! : ${e.message}`;
        document.body.textContent = "";
        document.body.appendChild(el);
    }
})();


//# sourceMappingURL=index.4dad024e.js.map
